module.exports = __webpack_public_path__ + "img/long-dark-monochrome-transparent.029ba27.svg";